<template>
  <BCard class="min-w-[100px]">
    <div class="mb-2">
      <div class="flex gap-[12px]">
        <BButton
          variant="primary"
          size="sm"
          class="rounded-[6px]"
          @click="goBack"
        >
          <img
            class="w-[20px]"
            src="https://storage.googleapis.com/komerce/assets/komerce-icon/Putih/arrow-left-2.svg"
            alt="arrow left"
          >
        </BButton>
        <div class="text-black font-semibold text-[24px]">
          Detail Riwayat Langganan -
          <span class="capitalize">{{ platform }}</span>
        </div>
      </div>
    </div>
    <div class="d-flex justify-content-end mb-2">
      <BCol
        md="3"
        class="mt-1 mt-md-0"
      >
        <DateRangePicker
          ref="picker"
          v-model="dateRange"
          :locale-data="locale"
          :ranges="ranges"
          :opens="'left'"
          class="w-100"
          style="min-width: 170px !important"
        >
          <template v-slot:input="picker">
            <div class="d-flex justify-content-between align-items-center mx-1">
              <span
                v-if="
                  picker.startDate === null && picker.endDate === null
                "
                style="color: #11263C !important; text-wrap: nowrap;"
              >
                Pilih Tanggal - Pilih Tanggal
              </span>
              <span
                v-else
                style="color: #11263C !important; text-wrap: nowrap;"
              >
                {{ DDMMMMYYYY(picker.startDate) }} -
                {{ DDMMMMYYYY(picker.endDate) }}
              </span>

              <img
                src="https://storage.googleapis.com/komerce/assets/icons/calendar.png"
                alt="Calendar"
                class="h-5 ml-1"
              >
            </div> </template></DateRangePicker>
      </BCol>
    </div>

    <div class="border rounded-[8px] overflow-hidden">
      <BTable
        :items="subscriptionData"
        :fields="fields"
        striped
        hover
        show-empty
        empty-text="Tidak ada data"
        @scroll="handleScroll"
      >
        <template #cell(no)="{ index }">
          {{ index + 1 }}
        </template>
        <template #cell(start_date)="{ item }">
          {{ DDMMMMYYYY(item.created_at) }}
        </template>
        <template #cell(end_date)="{ item }">
          {{ DDMMMMYYYY(item.expired_at) }}
        </template>
        <template #cell(duration)="{ item }">
          {{ item.duration_day }} Hari
        </template>
      </BTable>
    </div>
  </BCard>
</template>

<script>
import {
  BCard, BCol, BButton, BTable,
} from 'bootstrap-vue'
import DateRangePicker from 'vue2-daterange-picker'
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'
import { newAxiosIns } from '@/libs/axios'
import {
  firstDateOfMonth, today, yesterday, last7,
} from '@/store/helpers'
import {
  YEAR_MONTH_DAY,
  DDMMMMYYYY,
  LABELDAY,
  LABELMONTH,
} from '@/libs/filterDate'

export default {
  name: 'HistorySubscription',
  components: {
    BCard,
    BCol,
    BButton,
    BTable,
    DateRangePicker,
  },
  data() {
    return {
      YEAR_MONTH_DAY,
      DDMMMMYYYY,
      LABELDAY,
      LABELMONTH,
      dateRange: {
        startDate: undefined,
        endDate: undefined,
      },
      locale: {
        format: 'dd/mm/yyyy',
        daysOfWeek: LABELDAY,
        monthNames: LABELMONTH,
      },
      ranges: {
        'Hari ini': [today, today],
        Kemarin: [yesterday, yesterday],
        '7 Hari Terakhir': [last7, today],
        'Bulan ini': [firstDateOfMonth, today],
      },
      fields: [
        { key: 'no', label: 'No' },
        { key: 'start_date', label: 'Tanggal Mulai Berlangganan' },
        { key: 'end_date', label: 'Tanggal Berakhir' },
        { key: 'duration', label: 'Durasi' },
      ],
      subscriptionData: [],
      loading: {
        table: false,
      },
      limit: 25,
      offset: 0,
      lastData: false,
    }
  },
  computed: {
    platform() {
      return this.$route.query.platform || 'meta'
    },
  },
  watch: {
    dateRange() {
      this.fetchData()
    },
  },
  mounted() {
    this.getSubscriptionData()
  },
  methods: {
    goBack() {
      this.$router.push(
        `/komads/data-partner/${this.$route.params.id}/detail?platform=${this.platform}`,
      )
    },
    /**
     * Get subscription data from API
     * @returns {Promise<void>}
     */
    async getSubscriptionData() {
      this.loading.table = true

      const params = {
        limit: this.limit,
        offset: this.offset,
        platform_name: this.platform,
        transaction_type: 'subscription',
        start_date: this.dateRange.startDate
          ? YEAR_MONTH_DAY(this.dateRange.startDate)
          : null,
        end_date: this.dateRange.endDate
          ? YEAR_MONTH_DAY(this.dateRange.endDate)
          : null,
        user_id: this.$route.params.id,
      }

      try {
        const { data } = await newAxiosIns.get(
          'komads/api/v1/admin/whitelist_accounts/transactions',
          { params },
        )
        this.subscriptionData = data.data || []
        this.offset += data.data.length || 0
        this.lastData = (data.data.length || 0) < this.limit
      } catch (error) {
        this.$toast_error({
          message: 'Gagal mengambil data subscription',
        })
        this.subscriptionData = []
      } finally {
        this.loading.table = false
      }
    },
    fetchData() {
      this.offset = 0
      this.lastData = false
      this.getSubscriptionData()
    },
    handleScroll(event) {
      const table = event.target || document.getElementById('table')
      if (
        table.scrollTop >= table.scrollHeight - table.offsetHeight - 20
        && !this.loadingTable
        && !this.lastData
      ) {
        this.getNextSubscriptionData()
      }
      if (table.scrollTop === 0) {
        setTimeout(() => {
          table.scrollTop = 1
          setTimeout(() => {
            table.scrollTop = 0
          }, 10)
        }, 10)
      }
    },
    /**
     * Get next page of subscription data
     * @returns {Promise<void>}
     */
    async getNextSubscriptionData() {
      if (this.lastData || this.loading.table) return

      this.loading.table = true

      const params = {
        limit: this.limit,
        offset: this.offset,
        platform_name: this.platform,
        transaction_type: 'subscription',
        start_date: this.dateRange.startDate
          ? YEAR_MONTH_DAY(this.dateRange.startDate)
          : null,
        end_date: this.dateRange.endDate
          ? YEAR_MONTH_DAY(this.dateRange.endDate)
          : null,
      }

      try {
        const { data } = await newAxiosIns.get(
          `komads/api/v1/admin/partners/${this.$route.params.id}/whitelist_transactions`,
          { params },
        )
        const newData = data.data || []
        this.subscriptionData.push(...newData)
        this.offset += newData.length
        this.lastData = newData.length < this.limit
      } catch (error) {
        this.$toast_error({
          message: 'Gagal mengambil data subscription',
        })
      } finally {
        this.loading.table = false
      }
    },
  },
}
</script>
